module.exports = __webpack_public_path__ + "img/58.6ef51b70.png";